export const TITLE = 'Your identity is being verified';

export const DESCRIPTION =
  'Thank you for providing identification information. You can view your verification status below';
